if (!customElements.get('liontek-product-fit')) {
  customElements.define('liontek-product-fit', class extends HTMLElement {
    connectedCallback() {
      this.details = this.closest('details');
      this.product = document.querySelector('.liontek-product');
      this.gallery = this.product?.querySelector('[data-product-photos]');
      if (!this.details || !this.gallery) return;
      this.update = () => {
        if (!this.details.open) return;
        const style = this.product.querySelector('.variant-input-wrap[data-handle="type"] input:checked')?.value || this.product.querySelector('.se-option[data-name="Type"] .se-selected-value')?.textContent.trim() || '';
        const label = style.toLowerCase();
        const matchesStyle = img => {
          const src = (img.getAttribute('src') || '').toLowerCase();
          if (!/sizeguide|size-guide|size_chart|sizechart/.test(src)) return false;
          if (/thumb|short/.test(label)) return /thumb|short/.test(src);
          if (/pinky|ring/.test(label)) return /pinky|ring/.test(src);
          if (/double/.test(label)) return /double/.test(src);
          if (/triple/.test(label)) return /triple/.test(src);
          return /single/.test(label) && /single/.test(src) && !/thumb|short/.test(src);
        };
        const sources = [...this.querySelector('[data-fit-sources]').content.querySelectorAll('img'), ...this.gallery.querySelectorAll('img')];
        const source = sources.find(matchesStyle);
        const host = this.querySelector('[data-fit-chart]');
        this.querySelector('[data-fit-empty]').hidden = !!source;
        if (!source) { host.replaceChildren(); return; }
        if (host.firstElementChild?.getAttribute('src') === source.getAttribute('src')) return;
        const image = source.cloneNode();
        image.className = 'liontek-fit-chart';
        image.alt = style ? `${style} finger sleeve size guide` : 'Finger sleeve size guide';
        image.loading = 'lazy';
        image.fetchPriority = 'auto';
        image.sizes = '(min-width: 769px) 600px, 100vw';
        host.replaceChildren(image);
      };
      this.schedule = () => { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(this.update); };
      this.observer = new MutationObserver(this.schedule);
      this.onToggle = () => {
        this.observer.disconnect();
        if (this.details.open) {
          this.update();
          this.observer.observe(this.gallery, {childList:true,subtree:true,attributes:true,attributeFilter:['src','class','style']});
        }
      };
      this.onGuide = event => {
        if (event.target.closest('.liontek-product__fit-link')) this.details.open = true;
      };
      this.details.addEventListener('toggle', this.onToggle);
      document.addEventListener('click', this.onGuide);
      document.addEventListener('variant:change', this.schedule);
      this.onToggle();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.details?.removeEventListener('toggle', this.onToggle);
      document.removeEventListener('click', this.onGuide);
      document.removeEventListener('variant:change', this.schedule);
    }
  });
}

if (!customElements.get('liontek-sticky-cart')) {
  customElements.define('liontek-sticky-cart', class extends HTMLElement {
    connectedCallback() {
      this.product = document.getElementById(this.dataset.productSectionId);
      this.primary = this.product?.querySelector('[data-add-to-cart]');
      this.price = this.product?.querySelector('[data-product-price]');
      if (!this.primary || !this.price) return;
      this.button = this.querySelector('[data-sticky-button]');
      this.previewHeight = 0;
      this.seenPrimary = false;
      this.position = () => {
        const rect = this.primary.getBoundingClientRect();
        const headerBottom = document.getElementById('SiteHeader')?.getBoundingClientRect().bottom || 0;
        const primaryVisible = rect.top >= Math.max(0,headerBottom) && rect.bottom <= innerHeight - this.previewHeight;
        if (primaryVisible) this.seenPrimary = true;
        const passedPrimary = rect.bottom < Math.max(0,headerBottom);
        if (this.hidden !== !passedPrimary) this.hidden = !passedPrimary;
        this.chooseFirst = this.dataset.hasOptions === 'true' && !this.seenPrimary;
        this.sync();
      };
      this.schedule = () => { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(this.position); };
      this.sync = () => {
        const text = this.primary.querySelector('[data-add-to-cart-text]')?.textContent.trim() || this.primary.textContent.trim();
        const buttonText = this.chooseFirst ? this.dataset.chooseLabel : text;
        if (this.button.textContent !== buttonText) this.button.textContent = buttonText;
        const disabled = !this.chooseFirst && (this.primary.disabled || this.primary.classList.contains('btn--loading'));
        if (this.button.disabled !== disabled) this.button.disabled = disabled;
        const stickyPrice = this.querySelector('[data-sticky-price]');
        const priceText = this.price.textContent.trim();
        if (stickyPrice.textContent !== priceText) stickyPrice.textContent = priceText;
        const option = this.product.querySelector('[data-product-select] option:checked');
        const variant = this.querySelector('[data-sticky-variant]');
        const variantText = option?.textContent.trim().split(' - ')[0] || '';
        if (variant && variant.textContent !== variantText) variant.textContent = variantText;
      };
      this.onClick = () => {
        if (this.chooseFirst) {
          const target = this.product.querySelector('.se-option') || this.primary;
          target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
          target.querySelector('[role="radio"][aria-checked="true"]')?.focus({preventScroll:true});
          return;
        }
        if (!this.primary.disabled) this.primary.form.requestSubmit(this.primary);
      };
      this.edit = this.querySelector('[data-sticky-edit]');
      this.onEdit = () => {
        const target = this.dataset.hasOptions === 'true' ? this.product.querySelector('.se-option') || this.primary : this.primary;
        target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
        const focus = target.querySelector('[role="radio"][aria-checked="true"]') || this.primary;
        focus.focus({preventScroll:true});
      };
      this.button.addEventListener('click',this.onClick);
      this.edit.addEventListener('click',this.onEdit);
      this.mutations = new MutationObserver(this.sync);
      this.mutations.observe(this.primary,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','class']});
      this.mutations.observe(this.price,{subtree:true,childList:true,characterData:true});
      this.variantChanged = () => requestAnimationFrame(this.sync);
      document.addEventListener('variant:change',this.variantChanged);
      addEventListener('scroll',this.schedule,{passive:true});
      addEventListener('resize',this.schedule);
      this.bindPreview = () => {
        const preview = document.getElementById('PBarNextFrameWrapper');
        if (!preview || this.preview) return;
        this.preview = preview;
        this.previewWait?.disconnect();
        this.previewResize = new ResizeObserver(() => {
          this.previewHeight = Math.max(0,preview.getBoundingClientRect().height);
          this.style.setProperty('--preview-height', `${this.previewHeight}px`);
          this.schedule();
        });
        this.previewResize.observe(preview);
      };
      if (window.Shopify?.theme?.role !== 'main') {
        this.previewWait = new MutationObserver(this.bindPreview);
        this.previewWait.observe(document.body,{childList:true});
        this.bindPreview();
      }
      this.position();
    }
    disconnectedCallback() {
      this.mutations?.disconnect();this.previewWait?.disconnect();this.previewResize?.disconnect();
      cancelAnimationFrame(this.frame);
      this.button?.removeEventListener('click',this.onClick);
      this.edit?.removeEventListener('click',this.onEdit);
      document.removeEventListener('variant:change',this.variantChanged);
      removeEventListener('scroll',this.schedule);removeEventListener('resize',this.schedule);
    }
  });
}

function liontekEnhanceProduct(root = document) {
  const product = root.matches?.('.liontek-product') ? root : root.querySelector('.liontek-product');
  if (!product || product.dataset.liontekEnhanced) return;
  product.dataset.liontekEnhanced = 'true';
  const abort = new AbortController();
  const signal = abort.signal;
  const update = () => {
    const selected = product.querySelector('[data-product-select] option:checked');
    const summary = product.querySelector('[data-liontek-selection]');
    if (summary && product.querySelector('[data-variant-input]')) summary.textContent = `${selected?.textContent.trim().split(' - ')[0] || ''} · `;
    const buttonPrice = product.querySelector('[data-liontek-button-price]');
    if (buttonPrice) buttonPrice.textContent = product.querySelector('[data-product-price]')?.textContent.trim() || '';
  };
  const price = product.querySelector('[data-product-price]');
  const observer = new MutationObserver(update);
  if (price) observer.observe(price,{childList:true,subtree:true,characterData:true});
  document.addEventListener('variant:change',update,{signal});
  product.addEventListener('change',()=>requestAnimationFrame(update),{signal});
  document.addEventListener('click',event=>{
    const link = event.target.closest('[data-liontek-style]');
    if (!link) return;
    const input = [...product.querySelectorAll('.variant-input-wrap[data-handle="type"] input')].find(i=>i.value === link.dataset.liontekStyle);
    if (!input) return;
    event.preventDefault();input.click();
    const heading = product.querySelector('h1');
    if (heading) { heading.tabIndex = -1; heading.focus({preventScroll:true}); }
    window.scrollTo({top:0,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  },{signal});
  update();
  document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(product)){observer.disconnect();abort.abort()}},{signal});
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>liontekEnhanceProduct());else liontekEnhanceProduct();
document.addEventListener('shopify:section:load',event=>liontekEnhanceProduct(event.target));

function liontekOpenReviews() {
  if (!/judgeme|reviews/.test(location.hash)) return;
  const panel = document.getElementById('LiontekAllReviews');
  if (panel) panel.open = true;
}
addEventListener('hashchange',liontekOpenReviews);
liontekOpenReviews();
document.addEventListener('click',event=>{
  if(event.target.closest('.jdgm-prev-badge, a[href*="#judgeme_product_reviews"]')) {
    const panel=document.getElementById('LiontekAllReviews');if(panel) panel.open=true;
  }
},true);
